import React, { useEffect, useState } from "react";
import LandingSliderPages from "../section/LandingSliderPages";
import { Link } from "react-router-dom";
import { addToCart } from "../utils/cartUtils";
import { toast } from "react-toastify";
import axios from "axios";

export default function BestSeller() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // جلب البيانات من الـ API
  useEffect(() => {
    console.log("Fetching products...");
    axios
      .get("https://laravel-api.petra-ms.com/api/products")
      .then((response) => {
        console.log("API Response:", response.data);
        if (response.data.success) {
          setProducts(response.data.data);
        } else {
          setError("API returned success: false");
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching products:", error);
        setError(error.message);
        setLoading(false);
      });
  }, []);

  const handleAddToCart = (item) => {
    const cartItem = {
      id: item.id,
      name: item.product_name,
      price: item.product_price,
      image: `https://laravel-api.petra-ms.com/storage/app/public/${item.product_img}`,
    };
    addToCart(cartItem);
    toast.success(`${item.product_name} added to cart!`, {
      position: "top-right",
      autoClose: 2000,
    });
  };

  // عرض البيانات
  const showData = products.map((el) => (
    <Link
      to={`/items-details/${el.id}`}
      key={el.id}
      className="flex bg-white p-[15px] rounded-[8px] gap-[30px]"
    >
      <div className="w-[20%]">
        <img
          className="w-full h-full object-cover rounded-[8px]"
          src={`https://laravel-api.petra-ms.com/storage/app/public/${el.product_img}`}
          alt={el.product_name}
          onError={(e) => console.log(`Failed to load image: ${e.target.src}`)}
        />
      </div>
      <div className="flex flex-col justify-between gap-[30px]">
        <div>
          <div className="text-[20px] font-bold capitalize">{el.product_name}</div>
          <p className="text-[#979797]">{el.product_description}</p>
        </div>
        <div className="flex flex-col gap-[8px]">
          <div className="font-bold">{el.product_price} {el.product_currency}</div>
          <button
            onClick={(e) => {
              e.preventDefault();
              handleAddToCart(el);
            }}
            className="w-fit py-[10px] px-[40px] flex items-center justify-center bg-[#20BCB4] text-white rounded-[4px] h-10"
          >
            <span>Add To Cart</span>
          </button>
        </div>
      </div>
    </Link>
  ));

  return (
    <>
      <section>
        <LandingSliderPages />
      </section>
      <section className="relative py-10">
        <div className="container flex flex-col gap-[12px]">
          {loading ? (
            <div className="text-center">Loading...</div>
          ) : error ? (
            <div className="text-center text-red-500">Error: {error}</div>
          ) : products.length === 0 ? (
            <div className="text-center">No products available.</div>
          ) : (
            showData
          )}
        </div>
      </section>
    </>
  );
}